import React from 'react';
import {FormattedMessage} from 'react-intl';

import {
  electronicTicketMatchIds,
  mobileTicketMatchIds,
  mobileTransferMatchIds,
  paperTicketMatchIds,
} from '../../../../utils/constants';

export const All = {
  name: 'all',
  displayName: 'All tickets',
};

export const getDeliveryNameFromMatchedIds = (findDeliveryIds = []) => {
  let foundDeliveryNamesOnMatch = '';
  if (findDeliveryIds.some((deliveryTypes) => paperTicketMatchIds.indexOf(deliveryTypes) >= 0)) {
    foundDeliveryNamesOnMatch = <FormattedMessage id="DeliveryName.print" defaultMessage="Paper" />;
  } else if (findDeliveryIds.some((deliveryType) => electronicTicketMatchIds.indexOf(deliveryType) >= 0)) {
    foundDeliveryNamesOnMatch = <FormattedMessage id="DeliveryName.electronic" defaultMessage="Electronic" />;
  } else if (findDeliveryIds.some((deliveryType) => mobileTicketMatchIds.indexOf(deliveryType) >= 0)) {
    foundDeliveryNamesOnMatch = <FormattedMessage id="DeliveryName.mobileTicket" defaultMessage="Mobile Ticket" />;
  } else if (findDeliveryIds.some((deliveryType) => mobileTransferMatchIds.indexOf(deliveryType) >= 0)) {
    foundDeliveryNamesOnMatch = <FormattedMessage id="DeliveryName.mobileTransfer" defaultMessage="Mobile Transfer" />;
  }

  return foundDeliveryNamesOnMatch;
};
